import { handleActions, combineActions } from 'redux-actions';
import { LOAD_USER_LOGIN, LOAD_USER_LOGIN_SSO } from '../constants';

const intialState = {
  loading: false,
  model: null,
  error: false,
};

const userLogInEmailReducer = handleActions(
  {
    [LOAD_USER_LOGIN.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_USER_LOGIN.CANCELLED,
      LOAD_USER_LOGIN.SUCCESS,
      LOAD_USER_LOGIN.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_USER_LOGIN.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_USER_LOGIN.ERROR]: (state, { payload }) => ({
      ...state,
      error: payload || state.model,
    }),
    [LOAD_USER_LOGIN_SSO.CLEAR]: () => intialState,
  },
  intialState,
);

export default userLogInEmailReducer;
